import { z } from 'zod';

/** Validation schema for the weekly configuration of LONG tournaments. */
export const longConfigSchema = z.object({
  availabilityDeadlineDay: z.enum([
    'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY',
  ], { errorMap: () => ({ message: 'Seleccioná un día de la semana' }) }),
  availabilityDeadlineTime: z
    .string()
    .regex(/^\d{2}:\d{2}$/, 'Hora inválida (formato HH:mm)'),
  minSchedulesRequired: z
    .number()
    .int()
    .min(1, 'Mínimo 1 horario requerido'),
  walkoversForDisqualification: z
    .number()
    .int()
    .min(1, 'Mínimo 1'),
  autoPublishRounds: z.boolean(),
});

export type LongConfigValues = z.infer<typeof longConfigSchema>;
